// extracted by mini-css-extract-plugin
export var ipRangeRemoveButton = "ip-range-remove-button_ZH7ou5WJfomC4I5T5Rtz";
export var ipRangeRemoveButtonDisabled = "ip-range-remove-button_disabled_zXD3PMS0zVr4iSNhzBAq";